import React, { useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import logo from "./logo.png";

const PDFformat = ({ data }) => {
  const pdfRef = useRef();

  const handleDownload = () => {
    const input = pdfRef.current;

    html2canvas(input, {
      scale: 2,
      useCORS: true,
      windowWidth: document.body.scrollWidth,
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      let heightLeft = pdfHeight;
      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, pdfWidth, pdfHeight);
      heightLeft -= pdf.internal.pageSize.getHeight();

      while (heightLeft > 0) {
        position -= pdf.internal.pageSize.getHeight();
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, pdfWidth, pdfHeight);
        heightLeft -= pdf.internal.pageSize.getHeight();
      }

      pdf.save("purchase-order.pdf");
    });
  };

  return (
    <div>
      <button onClick={handleDownload} type="button" className="btn btn-primary">
        Download PDF
      </button>

      {/* PDF content wrapper for horizontal scroll */}
     <div style={{ width: "100%", overflowX: "auto", marginTop: 20 }}>
  <div
    ref={pdfRef}
    style={{
      backgroundColor: "#fff",
      color: "#000",
      padding: 20,
      minWidth: "1000px", // ensure large table
      boxSizing: "border-box",
      maxWidth: "100%",
    }}
  >

          <img
            src={logo}
            alt="Logo"
            style={{
              width: 70,
              height: "auto",
              marginRight: 20,
            }}
          />
          <h2 style={{ textAlign: "center" }}>
            Purchase Order - Ekta Foundation
          </h2>
          <p style={{ textAlign: "center" }}>
            Block B, Plot No, Kiran Garden, Uttam Nagar, Delhi, 110059
          </p>

          <table
            border="1"
            cellPadding="6"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: 20,
            }}
          >
            <thead style={{ backgroundColor: "#f0f0f0" }}>
              <tr>
                <th>S.No</th>
                <th>Kitchen Name</th>
                <th>Vendor Name</th>
                <th>Item Name</th>
                <th>Quantity</th>
                <th>Approved Qty</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.kitchen_name || "-"}</td>
                    <td>{item.vendor_name || "-"}</td>
                    <td>{item.stock_name || "-"}</td>
                    <td>{item.requested_quantity || 0}</td>
                    <td>{item.approve_queantity || 0}</td>
                    <td>{item.approval_date || "-"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center" }}>
                    No items found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PDFformat;
